<template>
  <div>
    <router-view
      :param="param"
      @setStep="setStep"
    />
  </div>
  </div>
</template>

<script>

import {
  ticketVerify
} from '@/api/official'

export default {
  data() {
    return {
      step: 1,
      param: {},
    }
  },
  created () {
    this.$store.commit('changeTab', '/events')
    this.step = parseInt(this.$route.params.step)
    this.param = this.$route.query
    this.initData()
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    initData () {
      if(this.$route.params.dec) {
        ticketVerify({ dec: this.$route.params.dec })
          .then(res => {
            if(res.code == 0) {
              if(res.data.info) {
                this.param = res.data.info
                this.setStep(5, { ...res.data.info, date: res.data.info.birthday })
              }else {
                this.param = {serial_no: res.data.serial_no}
                this.setStep(1, {serial_no: res.data.serial_no})
              }
            }else {
              this.setStep(1)
            }
          })
          .catch(err => {
            // console.log(err)
            this.setStep(1)
          })
      }
    },
    setStep(step, param) {
      if(param) {
        this.param = param 
      }

      let query = param || this.$route.query
      if(step === 1) {
        this.$router.replace({ name: 'upcoming-activate-step' + step, params: { step: step }, query: { ...query } })
      }else {
        this.$router.push({ name: 'upcoming-activate-step' + step, params: { step: step }, query: { ...query } })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
